var map = {
	"./1.png": 304,
	"./2.png": 163,
	"./3.png": 58,
	"./4.png": 181,
	"./5.png": 916,
	"./6.png": 919,
	"./7.png": 78,
	"./8.png": 945,
	"./9.png": 824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;